<script setup lang="ts">
import crystalBallXs from "~/assets/icons/crystalball/crystalball-xs.svg"
import findXs from "~/assets/icons/find/find-xs.svg"

defineProps({
  folder: null
})
const { navigateToFolder, openFolderInNewTab } = useNavigation()
const { openInstantMenuWithFileIn } = useInstantMenu()
const { askAgentAboutAFile } = useAgent()
</script>

<template>
  <div>
    <menu-section>
      <dropdown-item
        @click="navigateToFolder(folder)"
      >
        Open
      </dropdown-item>
      <dropdown-item
        @click="openFolderInNewTab(folder)"
      >
        Open in new tab
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item @click="askAgentAboutAFile(folder)">
        <div class="icon-item">
          <div class="icon">
            <crystal-ball-xs />
          </div>
          <div>Ask Poly...</div>
        </div>
      </dropdown-item>
      <dropdown-item @click="openInstantMenuWithFileIn(folder)">
        <div class="icon-item">
          <div class="icon">
            <find-xs />
          </div>
          <div>Search within...</div>
        </div>
      </dropdown-item>
    </menu-section>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.leave
  @apply font-bold text-$global-red-primary

.icon-item
  @apply inline-flex gap-1 inline-center
  .icon
    @apply w-4 h-4 flex items-center justify-center
</style>
